// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBloI5pzqx5peRFk43T6vNq59svofigSpQ",
  authDomain: "prokfy-admin.firebaseapp.com",
  projectId: "prokfy-admin",
  storageBucket: "prokfy-admin.appspot.com",
  messagingSenderId: "267007780437",
  appId: "1:267007780437:web:907cc1dba7a8ac6fd896dc",
  measurementId: "G-RSD6J7Q1BJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let messaging = null;

isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);

    // Register service worker only if supported
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration);
        });
    }

    // Listen for foreground messages
    onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload);
      if (Notification.permission === "granted") {
        new Notification(payload.notification?.title ?? "New Message", {
          body: payload.notification?.body,
          icon: "",
        });
      }
    });
  } else {
    console.warn("Firebase messaging is not supported in this browser.");
  }
});

// Request permission and get token
export const requestNotificationPermission = async () => {
  const supported = await isSupported();
  if (!supported) {
    console.warn("Firebase messaging is not supported in this browser.");
    return null;
  }
  try {
    if (!messaging) messaging = getMessaging(app);
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, { vapidKey: "BCutD9xwcuGs3wvHDAq-V0Mv1I10_f7oVGwqxSYK2fUknAtZefc5ndnkfm5npbL_ZJruGhii4zbX6Q8WWbTp5xk" });
      sessionStorage.setItem("firebaseNotificationToken", token);
      console.log("Notification Token:", token);
      return token;
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
  return null;
};
